/* ==========================================================================
   CERTIFICATE LOOKUP
   Matches on certificate number OR the vendor's stone number — people quote
   whichever one is in front of them.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-cert-lookup]');
  if (!root) return;

  var out = root.querySelector('[data-cert-result]');
  var input = root.querySelector('#cert-q');
  var stones = null;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function load() {
    if (stones) return Promise.resolve(stones);
    if (window.__DS_INDEX__) { stones = expand(window.__DS_INDEX__); return Promise.resolve(stones); }
    return fetch(root.getAttribute('data-index'))
      .then(function (r) { return r.json(); })
      .then(function (d) { stones = expand(d); return stones; });
  }

  function expand(data) {
    var f = data.fields;
    return data.rows.map(function (row) {
      var o = {};
      for (var i = 0; i < f.length; i++) o[f[i]] = row[i];
      return o;
    });
  }

  function find(q) {
    var n = String(q).trim().toUpperCase();
    if (!n) return null;
    return stones.filter(function (s) {
      return String(s.cert) === n || String(s.stone_no).toUpperCase() === n || String(s.id) === n;
    })[0] || null;
  }

  function render(q, stone) {
    if (!stone) {
      out.innerHTML =
        '<div class="se-empty"><h2>Not in our inventory</h2>' +
        '<p class="lede">We do not currently hold the stone on report ' + esc(q) + '.</p>' +
        '<ul><li>Stones sell, and reports stay in circulation — it may have gone.</li>' +
        '<li><a href="/pages/all-diamonds">Browse what we do have</a>, ' +
        'or <a href="/pages/contact">tell us what you are after</a> and we will look for it.</li></ul></div>';
      return;
    }
    var spec = ['Colour ' + stone.color, 'Clarity ' + stone.clarity];
    if (stone.cut) spec.push('Cut ' + stone.cut);
    out.innerHTML =
      '<section class="se-section"><h2>We have it</h2>' +
      '<div class="ds-grid-view"><article class="ds-card">' +
        '<div class="ds-card__media"><span class="ds-card__lab">' + esc(stone.lab) + '</span></div>' +
        '<div class="ds-card__body">' +
          '<h3 class="ds-card__title">' + stone.carat.toFixed(2) + 'ct ' + esc(stone.shape) +
            ' ' + esc(stone.growth) + ' Diamond</h3>' +
          '<p class="ds-card__spec">' + esc(spec.join(' · ')) + '</p>' +
          '<p class="ds-card__spec">' + (stone.lab && stone.cert ? 'Report ' + esc(stone.lab) + ' ' + esc(stone.cert) : 'Non-certified · certification available on request') + '</p>' +
          '<div class="ds-card__foot"><span class="ds-card__price">' + money(stone.price) + '</span>' +
          '<a class="ds-card__btn" href="/products/' + encodeURIComponent(stone.handle) + '">View diamond</a></div>' +
        '</div>' +
      '</article></div></section>';
  }

  root.querySelector('[data-cert-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return;
    out.innerHTML = '<div class="ds-loading">Checking…</div>';
    load().then(function () { render(q, find(q)); })
      .catch(function () {
        out.innerHTML = '<div class="se-empty"><h2>Could not check right now</h2>' +
          '<p class="lede">Please try again, or <a href="/pages/contact">send us the number</a>.</p></div>';
      });
  });

  // Deep link from the search page: /pages/certificate-lookup?cert=…
  var pre = new URLSearchParams(location.search).get('cert');
  if (pre) {
    input.value = pre;
    root.querySelector('[data-cert-form]').dispatchEvent(new Event('submit'));
  }
})();
